import some from 'lodash/some';
import every from 'lodash/every';

/**
 * Checks if array1 and array2 is different.
 * Loop through array1 and check if matching object properties exists in array2.
 *
 * @param array1
 * @param array2
 * @param properties
 */
export const unorderedArrayIsDiff = <T>(array1: T[], array2: T[], properties: (keyof T)[]): boolean => {
  return (
    array1.length !== array2.length ||
    !every(array1, (item1) => some(array2, (item2) => every(properties, (key) => item1[key] === item2[key])))
  );
};
